export default ({ style }) => (
	<svg
		id="Layer_3"
		data-name="Layer 3"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 27 27"
	>
		<path
			style={style}
			className="cls-1"
			d="M8.888,12.931a2.046,2.046,0,0,0,2.044,2.044,1.532,1.532,0,0,1,1.091.452,2.047,2.047,0,0,0,2.89,0,1.534,1.534,0,0,1,1.092-.452,2.046,2.046,0,0,0,2.044-2.044,1.534,1.534,0,0,1,.452-1.092,2.045,2.045,0,0,0,0-2.89,1.532,1.532,0,0,1-.452-1.092,2.046,2.046,0,0,0-2.044-2.044,1.534,1.534,0,0,1-1.092-.452,2.045,2.045,0,0,0-2.89,0,1.532,1.532,0,0,1-1.091.452A2.046,2.046,0,0,0,8.888,7.857a1.532,1.532,0,0,1-.452,1.092,2.045,2.045,0,0,0,0,2.89A1.534,1.534,0,0,1,8.888,12.931ZM8.789,9.3a2.033,2.033,0,0,0,.6-1.446,1.546,1.546,0,0,1,1.544-1.544,2.029,2.029,0,0,0,1.445-.6,1.546,1.546,0,0,1,2.183,0,2.028,2.028,0,0,0,1.445.6,1.546,1.546,0,0,1,1.544,1.544,2.036,2.036,0,0,0,.6,1.446,1.544,1.544,0,0,1,0,2.182,2.036,2.036,0,0,0-.6,1.446,1.546,1.546,0,0,1-1.544,1.544,2.032,2.032,0,0,0-1.445.6,1.545,1.545,0,0,1-2.183,0,2.033,2.033,0,0,0-1.445-.6,1.546,1.546,0,0,1-1.544-1.544,2.033,2.033,0,0,0-.6-1.446A1.546,1.546,0,0,1,8.789,9.3Z"
		/>
		<path
			style={style}
			className="cls-1"
			d="M13.468,13.787a3.393,3.393,0,1,0-3.393-3.393A3.4,3.4,0,0,0,13.468,13.787Zm0-6.286a2.893,2.893,0,1,1-2.893,2.893A2.9,2.9,0,0,1,13.468,7.5Z"
		/>
		<path
			style={style}
			className="cls-1"
			d="M17.375,15.688a.25.25,0,0,0-.469.174l1.609,4.316L16.528,19.7a.251.251,0,0,0-.261.1l-1.192,1.66-1.833-4.918a.25.25,0,0,0-.469.174l.563,1.509L12.13,21.46,10.939,19.8a.251.251,0,0,0-.261-.1l-1.987.476L10.3,15.862a.25.25,0,0,0-.469-.174L8.059,20.443a.251.251,0,0,0,.046.253.248.248,0,0,0,.247.077l2.279-.545L12,22.133a.249.249,0,0,0,.2.1l.033,0a.251.251,0,0,0,.2-.161L13.6,18.94l1.168,3.134a.248.248,0,0,0,.2.161l.033,0a.249.249,0,0,0,.2-.1l1.367-1.9,2.279.545a.249.249,0,0,0,.293-.33Z"
		/>
	</svg>
)
